import {ADD_GENERAL_INFO, ADD_USERS_INFO} from '../actions';

const INIT_STATE = {
  tokens: [],
  pairs: [],
  usersInfo: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_GENERAL_INFO:
      return {
        ...state,
        tokens: action.payload.tokens,
        pairs: action.payload.pairs,
      };
    case ADD_USERS_INFO:
      return {
        ...state,
        usersInfo: {
          ...state.usersInfo,
          [action.payload.id]: action.payload,
        }
      };
    default:
      return {...state};
  }
};
